/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Header from '../../components/Header';
import Content from '../../components/Content';
import CheckIfClassCompleted from '../../components/CheckIfClassCompleted';
import NextClass from './components/NextClass';
import ListCard from './components/ListCard';
import Footer from '../../components/Footer';
import LoadModal from '../../components/LoadModal';
import NoAccessModal from '../../components/NoAccessModal';
import Scheduling from '../../components/Scheduling';
import ListComments from './components/ListComments';
import FavoriteButton from '../../components/FavoriteButton';
import WarningCookie from '../../components/WarningCookie';
import Audio from '../../components/Audio';

import time from '../../assets/icons/time@2x.png';
import calendar from '../../assets/icons/calendar@2x.png';

import logoutUserAutomatically from '../../utils/logoutUserAutomatically';
import { handleError } from '../../services/handleError';
import api from '../../services/api';
import './skeleton.css';

import {
  Container,
  GradientBackground,
  Video,
  Thumbnail,
  Row,
  Description,
  TitleContainer,
  RowTitle,
  ScheduleClassButton,
  MenuLessonsAndComments,
  Item,
  ContainerAudioPlayer,
  ContainerVideoPlayer,
  MenuMobile,
  Spinner,
  ShowMoreLessons,
} from './styles';

const lessonDefault = {
  name: '',
  description: '',
  thumbnail: '',
  theme: '',
  post_id: '',
  filters: [],
  post: {
    id: '',
    lesson_history: [{ completed: false }],
  },
};

const Class = () => {
  const user = useSelector((state) => state.User);
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { pathname } = location;
  const vimeoVideoParameters = '?title=0&byline=0&portrait=0';

  const [showLoadModal, setShowLoadModal] = useState(false);
  const [showModalNextLessons, setShowModalNextLessons] = useState(false);
  const [lessonInformations, setLessonInformations] = useState(lessonDefault);
  const [lessonsOfSerie, setLessonsOfSerie] = useState([]);
  const [showNotAccessModal, setShowNoAccessModal] = useState(false);
  const [showSkeletonVideo, setShowSkeletonVideo] = useState(true);
  const [showSchedulingComponent, setShowSchedulingComponent] = useState(false);
  const [chosenMenu, setChosenMenu] = useState('Lessons');
  const [videoFinish, setVideoFinish] = useState(false);
  const [firstViewVideo, setFirstViewVideo] = useState(true);
  const [nextClassAutomatically, setNextClassAutomatically] = useState(false);
  const [serieID, setSerieID] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [showLoadNextLessons, setShowLoadNextLessons] = useState(false);

  const checkIfClassIsCompleted = async () => {
    let route = '';
    if (pathname.includes('podcast') || pathname.includes('meditacao')) {
      route = '/episodes';
    } else {
      route = '/lessons';
    }

    let completed = true;
    await api.get(`${route}/${lessonInformations.id}`).then((response) => {
      completed =
        response.data.post.lesson_history.length === 0
          ? false
          : response.data.post.lesson_history[0].completed;
      return completed;
    });

    return completed;
  };

  const handleOnEndedVideoAndPodcast = async () => {
    if (user.id.trim() !== '' && user.accessToken.trim() !== '') {
      const completed = await checkIfClassIsCompleted();

      if (!completed) {
        let route = '';
        if (pathname.includes('podcast') || pathname.includes('meditacao')) {
          route = '/episodes';
        } else {
          route = '/lessons';
        }

        api
          .post(`${route}/${lessonInformations.post.id}/history`, {
            completed: true,
          })
          .then((response) => setVideoFinish(true));
      }

      if (nextClassAutomatically) {
        checkIfClassHaveNextLesson();
      }
    }
  };

  const handleOnPlayVideo = async () => {
    if (firstViewVideo) {
      if (pathname.includes('podcast') || pathname.includes('meditacao')) {
        api.post(`/episode-views/${lessonInformations.id}`);
      } else {
        api.post(`/lesson-views/${lessonInformations.id}`);
      }

      setFirstViewVideo(false);
      castSrc();
    } else {
      stopSrc();
    }
  };

  const checkIfClassHaveNextLesson = () => {
    let nextLesson = false;

    let lessons = lessonsOfSerie;

    lessons.forEach((item) => {
      if (nextLesson) {
        nextLesson = false;

        let route = '';
        if (pathname.includes('podcast')) {
          route = `/podcast/aula/${item.id}`;
        } else if (pathname.includes('meditacao')) {
          route = `/meditacao/aula/${item.id}`;
        } else {
          route = `/aula/${item.id}`;
        }

        history.push(route);
      }

      if (item.id === lessonInformations.id) {
        nextLesson = true;
      }
    });

    return false;
  };

  function getEndpointLessonInformations() {
    if (pathname.includes('podcast') || pathname.includes('meditacao')) {
      return `/episodes/${id}`;
    } else {
      return `/lessons/${id}`;
    }
  }

  function getEndpointSerieLessons(serieID, addPage = false) {
    let pagination = page;
    if (addPage) {
      pagination++;
    }

    if (pathname.includes('podcast') || pathname.includes('meditacao')) {
      return `/podcast-series/${serieID}/episodes/published?limit=10000&page=${pagination}`;
    } else {
      return `/series/${serieID}/lessons/published?limit=10000&page=${pagination}`;
    }
  }

  const getAutoPlayStatusUser = async () => {
    await api
      .get(`/users/${user.id}`)
      .then((response) => setNextClassAutomatically(response.data.autoplay))
      .catch((error) => setNextClassAutomatically(false));
  };

  const getVideo = async (videoId) => {
    if (!videoId) return '';

    try {
      const { data } = await api.get(`/episodes/${videoId}/video`);

      return data.files[0].link || '';
    } catch (error) {
      handleError(error);
      console.log(error);
      return '';
    }
  };

  const loadLessonInformations = async () => {
    setShowLoadModal(true);

    await getAutoPlayStatusUser();

    let serieID;
    
    try {
      const endpoint = getEndpointLessonInformations();
      const response = await api.get(endpoint);

      const lastSegment = response?.data?.uri?.split('/')?.pop();
      const link = await getVideo(lastSegment);

      setLessonInformations({ ...response.data, uri: link });

      if (pathname.includes('podcast') || pathname.includes('meditacao')) {
        serieID = response.data.podcast_id;
      } else {
        serieID = response.data.series_id;
      }

      serieID && setSerieID(serieID);
    } catch (error) {
      console.log(error);
      handleError(error.response.data.message || error.message);
      history.push('/');
      setShowLoadModal(false);
      return;
    }

    setShowLoadModal(false);
    setShowModalNextLessons(true);

    if (!serieID) return setShowModalNextLessons(false);

    try {
      const endpoint = getEndpointSerieLessons(serieID);
      const response = await api.get(endpoint);
      if (pathname.includes('podcast') || pathname.includes('meditacao')) {
        setLessonsOfSerie(response.data.episodes);
      } else {
        setLessonsOfSerie(response.data.lessons);
      }
      setTotal(response.data.total);
    } catch (error) {
      // history.push('/');
      console.error('has error');
      return;
    }

    setShowModalNextLessons(false);
  };

  const showMoreLessons = async () => {
    setShowLoadNextLessons(true);
    setPage(page + 1);
    try {
      const endpoint = getEndpointSerieLessons(serieID, true);
      const response = await api.get(endpoint);

      if (pathname.includes('podcast') || pathname.includes('meditacao')) {
        setLessonsOfSerie([...lessonsOfSerie, ...response.data.episodes]);
      } else {
        setLessonsOfSerie([...lessonsOfSerie, ...response.data.lessons]);
      }
    } catch (error) {
      history.push('/');
      return;
    }

    setShowLoadNextLessons(false);
  };

  const handleClickThumbnailPodcastMeditation = () => {
    const myAudio = document.getElementById('podcast-audio');
    if (myAudio.paused) {
      myAudio.play();
    } else {
      myAudio.pause();
    }
  };

  function renderVideo() {
    if (lessonInformations.url_video) {
      return (
        <>
          <Video
            onlyAudio={false}
            showSkeletonVideo={showSkeletonVideo}
            src={`${lessonInformations.url_video}${vimeoVideoParameters}`}
            frameborder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            onLoad={() => setShowSkeletonVideo(false)}
          />
        </>
      );
    }

    if (
      lessonInformations.url === null ||
      lessonInformations.url === '' ||
      lessonInformations.url === undefined
    ) {
      return (
        <>
          <Thumbnail
            onLoad={() => setShowSkeletonVideo(false)}
            showSkeletonVideo={showSkeletonVideo}
            onClick={() => setShowNoAccessModal(true)}
            src={lessonInformations.thumbnail_url}
          />
        </>
      );
    }

    if (pathname.includes('podcast') || pathname.includes('meditacao')) {
      const startIndex = lessonInformations.url.lastIndexOf('/') + 1;
      const finishIndex = lessonInformations.url.length;
      const episodeKey = lessonInformations.url.substring(
        startIndex,
        finishIndex,
      );

      if (lessonInformations.url.indexOf('spreaker') >= 0) {
        const link = `https://widget.spreaker.com/player?episode_key=${episodeKey}&theme=light&playlist=false&playlist-continuous=false&autoplay=false&live-autoplay=false&chapters-image=true&episode_image_position=right&hide-logo=false&hide-likes=false&hide-comments=false&hide-sharing=false&hide-download=true`;

        return (
          <>
            <Video
              onlyAudio={true}
              showSkeletonVideo={showSkeletonVideo}
              src={link}
              frameborder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              onLoad={() => setShowSkeletonVideo(false)}
            />
          </>
        );
      } else {
        return (
          <ContainerAudioPlayer>
            <Thumbnail
              onLoad={() => setShowSkeletonVideo(false)}
              showSkeletonVideo={showSkeletonVideo}
              onClick={() => handleClickThumbnailPodcastMeditation()}
              src={lessonInformations.thumbnail_url}
            />
            <Audio
              id="podcast-audio"
              preload="metadata"
              onEnded={handleOnEndedVideoAndPodcast}
              controls
              controlsList="nodownload"
              onPlay={() => handleOnPlayVideo()}
              src={lessonInformations.audio_url}
            ></Audio>
          </ContainerAudioPlayer>
        );
      }
    }

    if (lessonInformations.url.indexOf('external') >= 0) {
      return (
        <ContainerVideoPlayer showSkeletonVideo={showSkeletonVideo}>
          <video
            onEnded={handleOnEndedVideoAndPodcast}
            onPlay={handleOnPlayVideo}
            onPause={stopSrc}
            controls
            controlsList="nodownload"
          >
            <source src={lessonInformations.url} type="video/mp4" />
          </video>
        </ContainerVideoPlayer>
      );
    }

    return (
      <>
        <Video
          onlyAudio={false}
          showSkeletonVideo={showSkeletonVideo}
          src={lessonInformations.uri}
          frameborder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          onLoad={() => setShowSkeletonVideo(false)}
        />
      </>
    );
  }

  function renderNoAccessModal() {
    if (setShowNoAccessModal) {
      return (
        <NoAccessModal
          show={showNotAccessModal}
          setShow={setShowNoAccessModal}
        />
      );
    }
  }

  function renderTitle() {
    let completed =
      lessonInformations.post.lesson_history.length === 0
        ? false
        : lessonInformations.post.lesson_history[0].completed;
    return (
      <RowTitle>
        <CheckIfClassCompleted
          videoFinish={videoFinish}
          completed={completed}
          post_id={lessonInformations.post.id}
          setShowLoadModal={setShowLoadModal}
        />
        <h1>{lessonInformations.name}</h1>
      </RowTitle>
    );
  }

  function renderDuration() {
    const { duration } = lessonInformations;
    if (duration > 0) {
      if (duration < 60) {
        return (
          <div>
            <img src={time} alt="Ícone de tempo da aula" />
            <span>{duration} min</span>
          </div>
        );
      } else {
        const hours = Math.trunc(duration / 60);
        const minutes = Math.trunc(duration - 60 * hours);
        return (
          <div>
            <img src={time} alt="Ícone de tempo da aula" />
            <span>
              {hours} {hours === 1 ? 'hora' : 'horas'}
              {minutes > 0 && ` e ${minutes} minutos`}
            </span>
          </div>
        );
      }
    }
  }

  function renderDescription() {
    return <p>{lessonInformations.description}</p>;
  }

  function renderListClasses() {
    return (
      <>
        <ListCard
          currentLesson={lessonInformations}
          nextLessons={lessonsOfSerie}
          pathname={pathname}
          setShowLoadModal={setShowLoadModal}
          setShowNoAccessModal={setShowNoAccessModal}
          checkIfUserHasAnActivePlan={checkIfUserHasAnActivePlan}
        />
        {renderShowMoreLessons()}
      </>
    );
  }

  function renderShowMoreLessons() {
    if (showLoadNextLessons) {
      return <Spinner />;
    }

    if (lessonsOfSerie.length < total) {
      return (
        <ShowMoreLessons onClick={() => showMoreLessons()}>
          Carregar mais vídeos
        </ShowMoreLessons>
      );
    }
  }

  function renderNextClass() {
    return (
      <NextClass
        currentLesson={lessonInformations}
        lessonsOfSerie={lessonsOfSerie}
        pathname={pathname}
        setShowLoadModal={setShowLoadModal}
        setShowNoAccessModal={setShowNoAccessModal}
        checkIfUserHasAnActivePlan={checkIfUserHasAnActivePlan}
      />
    );
  }

  function renderSchedulingComponent() {
    if (showSchedulingComponent) {
      return (
        <Scheduling
          type="aula"
          show={showSchedulingComponent}
          setShow={setShowSchedulingComponent}
          postId={lessonInformations.post_id}
        />
      );
    }
  }

  const checkIfUserHasAnActivePlan = async () => {
    try {
      const response = await api.get(`/users/plans`);
      const userPlan = response.data;
      if (userPlan.status === 'pending' || userPlan.status === 'suspended') {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleSchedule = async () => {
    if (!user.id.trim() || !user.accessToken.trim()) {
      setShowLoadModal(false);
      setShowNoAccessModal(true);
      return;
    }

    setShowLoadModal(true);

    const userHasAccess = await checkIfUserHasAnActivePlan();

    setShowLoadModal(false);

    if (userHasAccess) {
      setShowSchedulingComponent(true);
    } else {
      setShowNoAccessModal(true);
    }
  };

  function renderLessonsOrComments() {
    if (chosenMenu === 'Lessons') {
      if (showModalNextLessons) {
        return <Spinner />;
      }
      return (
        <>
          {renderNextClass()}
          <Content>{renderListClasses()}</Content>
        </>
      );
    }

    let route;
    if (pathname.includes('podcast') || pathname.includes('meditacao')) {
      route = `/episodes`;
    } else {
      route = `/lessons`;
    }

    return (
      <ListComments lessonInformations={lessonInformations} route={route} />
    );
  }

  function castSrc() {
    let mediaInfo = new window.chrome.cast.media.MediaInfo(1, 'video/mp4');
    mediaInfo.contentUrl = lessonInformations?.url;

    mediaInfo.streamType = window.chrome.cast.media.StreamType.LIVE;
    mediaInfo.metadata = new window.chrome.cast.media.TvShowMediaMetadata();
    mediaInfo.metadata.title = lessonInformations?.name;

    let request = new window.chrome.cast.media.LoadRequest(mediaInfo);
    request.autoplay = true;
    var session =
      window.cast.framework.CastContext.getInstance().getCurrentSession();
    if (session) {
      session
        .loadMedia(request)
        .then(() => {})
        .catch((e) => {});
    } else {
    }
  }

  function stopSrc() {
    var session =
      window.cast.framework.CastContext.getInstance().getCurrentSession();
    if (session) {
      var player = new window.cast.framework.RemotePlayer();
      var playerController = new window.cast.framework.RemotePlayerController(
        player,
      );
      playerController.playOrPause();
    }
  }

  useEffect(() => {
    if (id !== '' && id !== undefined) {
      setLessonInformations({
        name: '',
        description: '',
        thumbnail: '',
        theme: '',
        post_id: '',
        filters: [],
        post: {
          id: '',
          lesson_history: [{ completed: false }],
        },
      });

      setLessonsOfSerie([]);
      setFirstViewVideo(true);

      loadLessonInformations();
    }
    window.scrollTo(0, 0);

    if (logoutUserAutomatically()) {
      dispatch({ type: 'yoga-adm/user/logout' });
      history.push('/login');
    }
  }, [id]);

  function renderChromecastLauncher() {
    if (!pathname.includes('podcast') && !pathname.includes('meditacao')) {
      return <google-cast-launcher></google-cast-launcher>;
    }
  }

  return (
    <Container>
      <Header />
      <GradientBackground />
      <Content>
        {renderVideo()}
        <Description>
          <TitleContainer>
            <div>
              {renderTitle()}
              <MenuMobile>
                <CheckIfClassCompleted
                  videoFinish={videoFinish}
                  completed={
                    lessonInformations.post.lesson_history.length === 0
                      ? false
                      : lessonInformations.post.lesson_history[0].completed
                  }
                  post_id={lessonInformations.post.id}
                  setShowLoadModal={setShowLoadModal}
                />
                <FavoriteButton
                  post_id={lessonInformations.post_id}
                  is_favorite={lessonInformations.is_favorite}
                  favorite_id={lessonInformations.favorite_id}
                  setShowLoadModal={setShowLoadModal}
                />
              </MenuMobile>

              <ul>
                <li>
                  <FavoriteButton
                    post_id={lessonInformations.post_id}
                    is_favorite={lessonInformations.is_favorite}
                    favorite_id={lessonInformations.favorite_id}
                    setShowLoadModal={setShowLoadModal}
                  />
                </li>

                <li className="duration">{renderDuration()}</li>
              </ul>
            </div>
            {renderChromecastLauncher()}
          </TitleContainer>
          <Row>
            {renderDescription()}
            <ScheduleClassButton onClick={() => handleSchedule()}>
              <img src={calendar} alt="Ícone de calendário" />
              Agendar
            </ScheduleClassButton>
          </Row>
        </Description>
        <MenuLessonsAndComments>
          <Item
            chosenMenu={chosenMenu === 'Comments'}
            onClick={() => setChosenMenu('Comments')}
          >
            Comentários<div></div>
          </Item>
        </MenuLessonsAndComments>
      </Content>
      {renderLessonsOrComments()}
      <Footer />
      <LoadModal show={showLoadModal} />
      {renderNoAccessModal()}
      {renderSchedulingComponent()}
      <WarningCookie />
    </Container>
  );
};

export default Class;
